import { render, staticRenderFns } from "./CommissionActionRevoke.vue?vue&type=template&id=9b8f624c&"
import script from "./CommissionActionRevoke.vue?vue&type=script&lang=ts&"
export * from "./CommissionActionRevoke.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports